import { render, staticRenderFns } from "./menu-setting-index.vue?vue&type=template&id=7d97caec&scoped=true"
import script from "./menu-setting-index.vue?vue&type=script&lang=js"
export * from "./menu-setting-index.vue?vue&type=script&lang=js"
import style0 from "./menu-setting-index.vue?vue&type=style&index=0&id=7d97caec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d97caec",
  null
  
)

export default component.exports